import { GraphQLError } from 'graphql';
import ApiError from './api-error';

export function getErrorCode(error: Error | ApiError) {
  return error instanceof ApiError ? error.code : 0;
}

export function getErrorData<T>(error: Error | ApiError<T> | unknown): T | GraphQLError[] | undefined {
  if (error instanceof ApiError) {
    const errData = error.data;

    if (errData) {
      if ('errors' in errData) {
        const gqlErrData = (errData as unknown) as { errors: unknown[] };

        if (gqlErrData.errors.length && gqlErrData.errors[0] instanceof GraphQLError) {
          return gqlErrData.errors as GraphQLError[];
        }
      }

      return errData as T;
    }

    return errData;
  } else {
    const gqlErrCheck = (error as unknown) as Record<string, unknown>;
    return 'errors' in gqlErrCheck ? (gqlErrCheck.errors as T) : undefined;
  }
}

export function getErrorMessage(error: unknown) {
  return error instanceof Error ? error.message : String(error || 'Error information not available');
}
